<template>
  <b-form class="form-login" @submit="onSubmit" @reset="onReset">
    <slot></slot>
    <b-form-group v-if="signup_setting_hint" class="text-description">
      {{ signup_setting_hint }}
    </b-form-group>

    <b-form-group
      class="group-item"
      :label="displayPlaceholderOfUsername"
      label-for="login-name"
    >
      <b-form-input
        id="login-name"
        v-model="form.username"
        type="text"
        required
      ></b-form-input>
    </b-form-group>

    <b-form-group
      class="group-item"
      :label="displayPlaceholderOfPassword"
      label-for="login-password"
    >
      <b-form-input
        id="login-password"
        v-model="form.password"
        type="password"
        required
      ></b-form-input>
    </b-form-group>

    <div class="d-flex justify-content-between align-items-baseline flex-wrap row-gap-2">
      <div>
        <b-button
          class="btn-submit new-design-button"
          type="submit"
          variant="primary"
          >Login</b-button
        >

        <router-link v-if=" ! isTypeNoOne" class="ml-3 btn-link-lg" :to="'register'">
          Sign Up
        </router-link>
      </div>
      <a
        class="forgot-password"
        target="_blank"
        :href="displayLinkOfForgotPassword"
        >Forgot Password</a
      >
    </div>

    <div class="search-eportfolios-link">
      <router-link :to="'index'">
        <span> Search ePortfolios at {{ title }}</span>
      </router-link>
    </div>

    <b-modal ref="my-modal" title="Message">
      <p v-text="message"></p>
    </b-modal>
  </b-form>
</template>

<script>
import { CN_HOST } from "@/configs";
import { mapState, mapGetters } from "vuex";

export default {
  name: "form-login",
  props: {
    placeholderOfUsername: {
      type: String,
      default: "Email or CN Number",
    },
    placeholderOfPassword: {
      type: String,
      default: "Password",
    },
    forgotUrl: {
      type: String,
      default: `${CN_HOST}/requestresetpassword`,
    },
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      message: "",
    };
  },
  computed: {
    displayPlaceholderOfUsername() {
      return this.signin_placeholder_of_username || this.placeholderOfUsername;
    },
    displayPlaceholderOfPassword() {
      return this.signin_placeholder_of_password || this.placeholderOfPassword;
    },
    displayLinkOfForgotPassword() {
      return this.signin_link_of_forgot_password || this.forgotUrl;
    },
    ...mapState("siteBrand", [
      "title",
      "heading",
      "signup_setting_hint",
      "signin_redirection_page",
      "signin_placeholder_of_username",
      "signin_placeholder_of_password",
      "signin_link_of_forgot_password",
    ]),
    ...mapGetters("siteBrand", ["isTypeNoOne"]),
  },
  methods: {
    onSubmit: async function(evt) {
      evt.preventDefault();
      this.message = "";
      try {
        const { data } = await this.$http.get("auth", {
          headers: {
            username: this.form.username,
            password: this.form.password,
          },
          params: {
            action: "login",
          },
        });
        const {
          data: { token },
        } = data;
        if (token) {
          if (this.signin_redirection_page) {
            var signinRedirectionPage = encodeURIComponent(
              this.signin_redirection_page,
            );
            window.location.href = `${CN_HOST}/site/token/${token}/redirect_to/${signinRedirectionPage}`;
          } else {
            window.location.href = `${CN_HOST}/site/token/${token}`;
          }
        } else if (data.errors && data.errors.length) {
          this.message = data.errors.join(",");
          this.$refs["my-modal"].show();
        }
      } catch (error) {}
    },
    onReset(evt) {
      evt.preventDefault();
    },
  },
};
</script>

<style scoped lang="scss">
.forgot-password {
  font-weight: 600;
  font-size: rem(14);
  line-height: rem(20);
  color: #3574d9;
}

.new-design-button {
  width: rem(140);
  height: rem(40);
  background: #3574d9;
  box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  @media all and (max-width: 768px) {
    width: rem(120);
  }
}

.form-login {
  .group-item {
    color: #1a374d;
    opacity: 0.9;
    margin-top: rem(24);

    input {
      height: rem(48);
      background: #ffffff;
      border: rem(1) solid #babdcc;
      border-radius: rem(8);
    }
  }
}
</style>
